<template>
   <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{zIndex: options.zIndex}"
      persistent
      @keydown.esc="cancel"
   >
      <v-card>
         <v-toolbar dark :color="options.color" dense flat>
            <v-toolbar-title class="text-body-1 font-weight-bold white--text">
               {{ title }}
            </v-toolbar-title>
         </v-toolbar>
         <v-card height="60vh" class="overflow-y-auto">
            <v-card-text>
               <ol>
                  <v-card-subtitle class="ml-n8"
                     ><strong><u>Release and Indemnity</u></strong>
                  </v-card-subtitle>
                  <li>
                     I fully understand and accept that while every precaution and care will be
                     taken by the School, participation in the Activity may carry with it certain
                     risks which cannot be eliminated. I acknowledge and accept all of the inherent
                     risks associated with the Student’s participating in the Activity and the
                     possibility of personal injury, property damage or loss resulting from them and
                     agree to assume all the risks and waive notice of all conditions, danger or
                     otherwise, in or about the Activity
                  </li>
                  <li>
                     I agree to release, save harmless and indemnify the School, its employees,
                     invitees, volunteers and agents (herein collectively called “the Personnel”)
                     from and against all claims, actions, causes of action, costs, expenses
                     whatsoever in respect to injury, loss or damage to my person or property, in
                     connection with my taking part in the Activity or while travelling to and from
                     the Activity unless caused by act or negligence of the School or the Personnel
                  </li>
                  <li>
                     I further understand, acknowledge and agree that at any time the School
                     reserves the right to accept or decline continued participation to any persons,
                     including the Student, if in the judgement of any of the Personnel the
                     Student’s behaviour is causing unreasonable disturbance or danger to
                     himself/herself or any other participants or to the School.
                  </li>
                  <v-card-subtitle class="ml-n8">
                     <strong><u>Authorisation to attend to accident or emergency</u></strong>
                  </v-card-subtitle>
                  <li>
                     In the event of an accident or emergency, whilst every attempt will be made to
                     contact me, I hereby authorise the School or any of the Personnel to make such
                     arrangements as he/she deems necessary for the Student to receive
                     medical/hospital care, including necessary transportation. Under such
                     circumstances, I further authorise any designated medical practitioner to
                     undertake such care and treatment of the Student as he/she considers necessary,
                     including any x-ray examination, anaesthetic, medical, dental or surgical
                     diagnosis or treatment
                  </li>
                  <v-card-subtitle class="ml-n8">
                     <strong><u>Acknowledgement of Understanding</u></strong>
                  </v-card-subtitle>
                  <li>
                     I understand that the consent, release and indemnity granted herein are given
                     freely and voluntarily, and that I may revoke them at any time prior to the
                     commencement of the Activity by submitting the said revocation in writing to
                     the School. By doing so, I understand that the Student will not be able to
                     participate further in the Activity. I also understand that I have the ability
                     to refuse to sign this Form and if so the Student will not be permitted to
                     participate in the Activity.
                  </li>
               </ol>
            </v-card-text>
         </v-card>

         <v-card-actions class="py-5">
            <v-row justify="space-around">
               <v-btn
                  v-if="!options.noconfirm"
                  color="red"
                  outlined
                  width="120px"
                  class="body-2 font-weight-bold"
                  @click.native="cancel"
                  >I Do Not Agree</v-btn
               >
               <v-btn
                  color="success"
                  class="body-2 font-weight-bold"
                  width="120px"
                  outlined
                  @click.native="agree"
                  >I Agree
               </v-btn>
            </v-row>
         </v-card-actions>
      </v-card>
   </v-dialog>
</template>

<script>
   export default {
      //name: "ConfirmDlg",
      data() {
         return {
            dialog: false,
            resolve: null,
            reject: null,
            title: null,
            options: {
               color: "primary",
               width: 400,
               zIndex: 200,
               noconfirm: false,
            },
         };
      },

      methods: {
         open(title) {
            this.dialog = true;
            this.title = title;

            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },
         agree() {
            // console.log("agreed");
            this.resolve(true);
            this.dialog = false;
         },
         cancel() {
            // console.log("cancelled");
            this.resolve(false);
            this.dialog = false;
         },
      },
   };
</script>
